import React from 'react';
import FallbackCgi from '../../../../common/cgi/FallbackCgi';
import useImage from '../../../../common/images/useImage';

const BodyDetailsModalImage = ({ cgiImageUrl, alt }) => {
  const { hasError } = useImage(cgiImageUrl);

  if (hasError) {
    return <FallbackCgi fullSize />;
  }
  return (
    <div className="body-details-image">
      <img className="body-details-image__cgi" src={cgiImageUrl} alt={alt} />
    </div>
  );
};

export default BodyDetailsModalImage;
